<template>
  <!-- TODO: Replace this old burguer and use: <Bars3Icon class="h-6 w-6" aria-hidden="true" /> -->
  <div class="seo-a--menu-toogle">
    <div class="c-hamburguer relative">
      <span />
      <span />
      <span />
      <AuthUnread :sidebar-layout="true" />
    </div>
  </div>
</template>

<style scoped>
.seo-a--menu-toogle {
  width: 100%;
  height: 100%;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  justify-content: center;
}
.seo-a--menu-toogle span {
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: #374151;
  opacity: 1;
  left: 0;
}
.seo-a--menu-toogle span:nth-child(1) {
  top: 0px;
}
.seo-a--menu-toogle span:nth-child(2) {
  top: 8px;
}
.seo-a--menu-toogle span:nth-child(3) {
  top: 16px;
}

.c-hamburguer {
  color: #fff;
  display: block;
  height: 20px;
  width: 26px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
</style>
